export function extractUserFacingErrorMessage(value: unknown): string | null {
  if (typeof value === 'string') {
    const message = value.trim();

    return message.length > 0 ? message : null;
  }

  if (value instanceof Error) {
    const message = value.message.trim();

    return message.length > 0 ? message : null;
  }

  if (typeof value === 'object' && value !== null && 'message' in value) {
    const message = (value as { message?: unknown }).message;

    if (typeof message === 'string') {
      const trimmedMessage = message.trim();

      return trimmedMessage.length > 0 ? trimmedMessage : null;
    }
  }

  if (typeof value === 'object' && value !== null && 'errors' in value) {
    const errors = (value as { errors?: unknown }).errors;
    if (typeof errors === 'object' && errors !== null) {
      const errorValues = Object.values(errors as Record<string, unknown>);
      for (const errorValue of errorValues) {
        if (Array.isArray(errorValue)) {
          const firstMessage = errorValue.find(item => typeof item === 'string' && item.trim().length > 0);
          if (typeof firstMessage === 'string') {
            return firstMessage.trim();
          }
        }
      }
    }
  }

  return null;
}
